import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";

import {Nullable} from "../../models/common/Nullable";
import {
    FETCH_PROJECT_EMPLOYEES,
    FETCH_PROJECT_EMPLOYEES_ERROR,
    FETCH_PROJECT_EMPLOYEES_SUCCESS,
    FETCH_PROJECT_STAGE_EMPLOYEES, FETCH_PROJECT_STAGE_EMPLOYEES_ERROR, FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS,
    FETCH_PROJECT_STAGE_PHASE_EMPLOYEES,
    FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR,
    FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS,
    ProjectStagePhaseEmployeeActionTypes
} from "../../actions/projects/ProjectStagePhaseEmployeeActions";
import {ProjectStagePhaseTaskEmployee} from "../../models/projects/ProjectStagePhaseTaskEmployee";
import {MapByNum} from "../../models/common/Map";
import {
    PERSIST_PROJECT_EMPLOYEES, PERSIST_PROJECT_EMPLOYEES_ERROR,
    PERSIST_PROJECT_EMPLOYEES_SUCCESS, ProjectEmployeeViewActionTypes
} from "../../actions/projects/ProjectEmployeeActions";


export interface ProjectEmployeeState {
    phases: MapByNum< Nullable< ProjectStagePhaseTaskEmployee[] > >,
    stages: MapByNum< Nullable< ProjectStagePhaseTaskEmployee[] > >,
    projects: MapByNum< Nullable< ProjectStagePhaseTaskEmployee[] > >
    request: RequestState
}

const initialState: ProjectEmployeeState = {
    phases: {},
    stages: {},
    projects: {},
    request: getInitialRequestState()
};


export const ProjectEmployeeReducer = (
    state = initialState,
    action: ProjectStagePhaseEmployeeActionTypes | ProjectEmployeeViewActionTypes
) => {

    switch( action.type ) {
        case FETCH_PROJECT_STAGE_PHASE_EMPLOYEES:
            return {
                ...state,
                phases: {
                    ...state.phases,
                    [ action.phaseIdPath.phaseId.rawValue ]:  null
                },
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case FETCH_PROJECT_STAGE_PHASE_EMPLOYEES_SUCCESS:
            return {
                ...state,
                phases: {
                    ...state.phases,
                    [ action.phaseId.rawValue ]: action.payload.entries
                },
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_EMPLOYEES:
            return {
                ...state,
                projects: {
                    ...state.projects,
                    [ action.projectId.rawValue ]: null
                },
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_EMPLOYEES_SUCCESS:
            return {
                ...state,
                projects: {
                    ...state.projects,
                    [ action.projectId.rawValue ]: action.payload.entries
                },
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_EMPLOYEES_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case FETCH_PROJECT_STAGE_EMPLOYEES:
            return {
                ...state,
                stages: {
                    ...state.stages,
                    [ action.stageIdPath.projectStageId.rawValue ]: null
                },
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_STAGE_EMPLOYEES_SUCCESS:
            return {
                ...state,
                stages: {
                    ...state.stages,
                    [ action.projectStageId.rawValue ]: action.payload.entries
                },
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_STAGE_EMPLOYEES_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case PERSIST_PROJECT_EMPLOYEES:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case PERSIST_PROJECT_EMPLOYEES_SUCCESS:
            return {
                ...state,
                request: successFetchingRequestState()
            };
        case PERSIST_PROJECT_EMPLOYEES_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            }
        default:
            return state;
    }

}